import { get, isArray } from "lodash";
import React from "react";
import Functions from "../../src/functions";

function Mapper(data, status, response, error, component) {
  let output = [];
  if (data) {
    if (data.data) {
      data.data.map((itm, idx) => {
        let property = {};

        property["id"] = itm._id;
        property["simos"] = itm.firstName + " " + itm.lastName;
        property["birthday"] = itm.dob;

        output.push(property);
      });
    }
  }

  return output;
}

function Properties(args) {
  let editable = args.editable ? true : false;
  return {
    id: {
      alias: "id",
      type: "text",
      label: "ID",
      editable: editable,
    },
    simos: {
      alias: "simos",
      type: "text",
      label: "ID",
      editable: editable,
    },
    birthday: {
      alias: "birthday",
      type: "button",
      label: "ID",
      caption: "Click me",
      editable: editable,
      events: {
        onClick: function () {
          Functions["custom"].testFunction();
        },
      },
      attributes: {
        className: "btn btn-link",
        disabled: "disabled",
      },
    },
    test: {
      alias: "test",
      type: "module",
      configuration: {
        module: "page",
        view: "list",
      },
    },
  };
}

const Users = {
  auth: "",
  views: {
    list: {
      apis: {
        view: {
          data: {
            "data": [
              {
                "_id": "62b2465e0670000015000247",
                "firstName": "\u03a3\u0399\u039c\u039f\u03a3",
                "lastName": "\u039a\u0391\u039c\u0397\u039b\u0399\u0395\u03a1\u0397\u03a3",
                "email": "skamilieris@cognity.gr",
                "dob": "1982-03-08T22:00:00Z"
              },
              {
                "_id": "62b246a70670000015000248",
                "firstName": "\u03a3\u0399\u039c\u039f\u03a3",
                "lastName": "\u039a\u0391\u039c\u0397\u039b\u0399\u0395\u03a1\u0397\u03a3",
                "email": "kamilaki@hotmail.com"
              }
            ],
            "exceptions": [],
            "pagination": []
          },
          replace: {},
          mapper: Mapper,
        },
      },
      template: "table",
      templateConfiguration: {
        includeProperties: [],
        excludeProperties: [],
        events: {
          onSubmit: function (e) {},
        },
      },
      properties: Properties({ editable: true }),
      primaryKey: "id",
    },
  },
};

export default Users;
